import React from 'react'
import { Modal } from 'react-bootstrap'
import Table from 'react-bootstrap/Table'

const LocationModal = ({
  visible,
  onCancel,
  locationInfo,
  actionButtonText,
  websiteBackgroundColor,
  websiteTextColor,
}) => {

  const getURL = (slug, food_delivery_platform) => {
    let url = `${process.env.REACT_APP_ONLINE_ORDER_URL}/restaurant/${slug}`
    if (food_delivery_platform?.length > 0) {
      food_delivery_platform.forEach(({is_default_wesite_url, ordering_url}) => {
        if (is_default_wesite_url) {
          url = ordering_url
        }
      })
    }
    return url
  }

  return (
    <Modal show={visible} onHide={onCancel} aria-labelledby="contained-modal-title-vcenter" size="xs" centered>
      <Modal.Header closeButton style={{backgroundColor: websiteBackgroundColor, color: websiteTextColor}}>
        <Modal.Title><span className="custom-font-style">Choose a location</span></Modal.Title>
      </Modal.Header>
      <Modal.Body style={{backgroundColor: websiteBackgroundColor, color: websiteTextColor}}>
        <Table responsive striped hover>
          <tbody>
            {locationInfo?.map(({ business, food_delivery_platform }) => (
              <>
                <tr>
                  <td style={{backgroundColor: websiteBackgroundColor, color: websiteTextColor}}>
                    <strong>{business?.location_name ? business.location_name : business.location.address.city}</strong>
                    <br />
                    {business.location.address.street}{', '}{business.location.address.city}{', '}{business.location.address.state_province}{', '}{business.location.address.zip_postal_code}{', '}{business.location.address.country}
                    <br />
                    <center className="btn-spacing">
                      <a
                        href={getURL(business.slug, food_delivery_platform)}
                        className="btn-header btn-brand btn-footer"
                        rel="noreferrer"
                        target="_blank"
                      >
                        {actionButtonText}
                      </a>
                    </center>

                  </td>
                </tr>
              </>
            ))}
          </tbody>
        </Table>
      </Modal.Body>
    </Modal>
  )
}

export default LocationModal
